import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'atMention' })
export class AtMentionPipe implements PipeTransform {
  transform(text: string) {
    // Look for super rare '@*^$@%' at the end of the message to know where it ends.
    const regex = /@[^@]+@\*\^\$@%/g;
    const atMention = text.match(regex) || [];

    const classes = `body-bold`;
    const styles = 'margin-bottom: -6px; padding-top: 0; padding-bottom: 0; border-radius: 5px;';

    atMention.forEach((mention: string) => {
      text = text.replace(
        mention,
        `
            <ion-badge class="${classes}" style="${styles}">
              ${mention.substring(0, mention.toString().length - 6)}
            </ion-badge>
          `
      );
    });

    return text;
  }
}
